<template>
    <div>
        <checkbox-group :value.sync="selection"
                        type="success">
            <checkbox-btn :value="value.slug"
                          :class="'-' + value.slug"
                          v-for="value of filter.values">
                {{ value.label }}
            </checkbox-btn>
        </checkbox-group>
    </div>
</template>

<script type="text/ecmascript-6">
    import CheckboxGroup from 'vue-strap/src/checkboxGroup';
    import CheckboxBtn from 'vue-strap/src/checkboxBtn';

    export default {
        components: {
            CheckboxGroup,
            CheckboxBtn
        },
        props: {
            filter: {
                required: true
            },
            selection: {
                twoWay: true,
                required: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// EnumFilter.vue?38c8d291